// extracted by mini-css-extract-plugin
export default {"message":"NotFound_message__8u0IA","message_container":"NotFound_message_container__Xhaks"};